module.exports = __webpack_public_path__ + "media/images/signup-bg-39f4ba60ee0e6c45e2f1f5dc48f40023.png";